import { StudentAIInterviewType } from '../enums';

export interface ProgressCount {
  progressCount: number;
}

export interface StudentSituationMemo {
  id?: number,
  registerDate?: Date;
  situationMemo?: string;
  studentId?: number;
  userId?: number;

  // メモデータ
  situationMemoData?: {
    memo?: string;
    orderOfPreference?: string;
    nextAction?: string;
  }
}

export interface ActiveCount {
  activeCount: number;
}

export interface Student {
  '@timestamp': Date;
  '@version': string;
  activeCount: ActiveCount[];
  createdAt: Date;
  deletedAt?: any;
  dynamicData: any;
  frontId: string;
  id: number;
  lastContactedAt: Date;
  lastMailReceivedAt?: any;
  lastUpdatedAt: Date;
  mypageLoggedInAt: Date;
  progressCount: ProgressCount[];
  registeredAt: Date;
  registerUserId: number;
  studentSituationMemo: StudentSituationMemo[];
  studentUser: StudentUser[];
  syncTriggerAt: Date;
  tags: string[];
  type: string;
  updatedAt: Date;
  updateUserId: number;
  studentNotes?: StudentNote[];
  caUserId?: number;
}
export interface StudentDetail {
  id: number;
  frontId: string;
  registerUserId: number;
  updateUserId: number;
  registeredAt: string | Date;
  lastUpdatedAt: string | Date;
  lastMypageNotificationEmailSentAt: string | Date;
  publishMypage: boolean; // DBには存在しないけど、フロントでは表示に使う値
  mypageLoggedInAt: string | Date;
  dynamicData: any;
  lastContactDate: string | Date;
  studentUsers: StudentUser[];
  studentSubUsers: StudentSubUser[];
  userId?: number;
  subUserIds?: number[];
  studentNotes?: StudentNote[];
}

export interface StudentUser {
  id: number;
  type: number;
  userId: number;
}

export interface StudentSubUser {
  id: number;
  type: number;
  userId: number;
}

export interface StudentNote {
  id?: number;
  note: string;
  createdAt?: string | Date;
  updatedAt?: string | Date;
}

/**
 * 求職者一覧
 */
export interface StudentList {
  total: number;
  students: Student[];
}

/**
 * ヨミ区分（MACH_PJ-588）
 */
export enum YomiType {
  Kata = "カタ",
  FCST = "FCST",
  Hoshi = "★",
  Nobi = "ノビ",
  MinusKata = "マイナスカタ",
  MinusFCST = "マイナスFCST",
  MinusHoshi = "マイナス★",
  MinusNobi = "マイナスノビ",
}
export const YOMI_TYPE_CODES = [YomiType.Kata, YomiType.FCST, YomiType.Hoshi, YomiType.Nobi, YomiType.MinusKata, YomiType.MinusFCST, YomiType.MinusHoshi, YomiType.MinusNobi];


export interface StudentSuggestResponse {
  id: number;
  frontId: string;
  lastName: string;
  firstName: string;
  age: number;
  prefecture: string;
  schoolName: string;
  schoolDepartmentName: string;
  studentUser: {
    id: number;
    userId: number;
    type: number;
  }[];
  emailMain: string;
  emailMainAvailable: null | '不可';
  emailSub: string;
  emailSubAvailable: null | '不可';
}

export interface StudentImportFile {
  id: number;
  status: number;
  originalFilename: string;
  storageKey: string;
  successCount: number;
  errorCount: number;
  createdDate: string;
}

export interface StudentImportQueue {
  id: number;
  status: number;
  successCount: number;
  errorCount: number;
  errorList: StudentImportQueueError[];
}

export interface StudentImportQueueError {
  id: number;
  studentImportFileId: number;
  type: number;
  registrationRoute: string;
  name: string;
  importData: string;
  duplicatedStudentId: number;
  duplicatedStudentImportErrorId: number;
  duplicatedStudentFrontId: string;
  entriedAt: string;
  resolvedAt: string;
  firstRegistrationDate: string;
}

export interface StudentImportErrorDetail {
  id: number;
  studentImportFileId: number;
  type: number;
  registrationRoute: string;
  name: string;
  importData: string;
  errorFields: { [key: string]: any };
  duplicatedStudentId: number;
  duplicatedStudentFrontId: string;
  duplicatedStudentImportErrorId: number;
  entriedAt: string;
  resolvedAt: string;
  studentImportFile: StudentImportFile;
  importedStudent: {
    dynamicData?: any;
    studentUsers?: {
      userId: number;
      type: number;
    }[];
  };
}

export interface StudentImportDiff {
  dbStudent: StudentImportDiffStudent;
  csvStudent: Partial<StudentImportDiffStudent>;
  dbStudentUserId: number;
  csvStudentUserId: number;
  duplicateCount: number;
}

export interface StudentImportDiffStudent {
  id: number;
  frontId: string;
  registerUserId: number;
  updateUserId: number;
  registeredAt: string;
  lastUpdatedAt: string;
  mypageLoggedInAt: string;
  dynamicData: any;
}

export interface StudentImportErrorDeleteRequest {
  importErrorIds: number[];
}

export interface StudentReimportRequest {
  dynamicData?: any;
  userId?: number | null;
  force?: number;
}

export interface StudentUpdateRequest {
  dynamicData: any;
  userId?: number | null;
}

export interface StudentAIInterviewRequest {
  type: StudentAIInterviewType;
  dynamicData?: any;
}

export interface StudentAIInterviewResult {
  id: number;
  studentId: number;
  type: StudentAIInterviewType;
  dynamicData?: any;
  createdAt: Date;
  updatedAt: Date;
  deletedAt?: Date;
}
